import { all } from 'redux-saga/effects';
import { watchLoginSaga, watchCheckAuthSaga } from './authSaga';
export default function* rootSaga() {
  yield all([watchLoginSaga(), watchCheckAuthSaga()]);
}
